<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="btn-close" aria-label="Fechar" (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">

    <!-- 1. Nome -->
    <div class="mb-3">
      <label class="form-label" for="event-name">Nome do Evento <span class="text-danger">*</span></label>
      <input
        id="event-name"
        type="text"
        class="form-control"
        formControlName="name"
        maxlength="120"
        placeholder="ex: order.created"
        data-testid="event-name"
      />
      <div *ngIf="form.get('name')?.invalid && form.get('name')?.touched" class="text-danger small mt-1">
        Nome obrigatório (até 120 caracteres)
      </div>
    </div>

    <!-- 2. Payload Example (JSON) -->
    <div class="mb-3">
      <label class="form-label" for="event-payload-example">
        Exemplo de Payload (JSON) <span class="text-danger">*</span>
      </label>
      <p class="small text-muted">
        Cole um exemplo do JSON que será enviado pela plataforma. Ao sair do campo, os caminhos serão
        extraídos automaticamente para uso nas condições e no mapeamento.
      </p>
      <textarea
        id="event-payload-example"
        class="form-control"
        formControlName="payload_example"
        rows="8"
        (blur)="onPayloadExampleBlur()"
        placeholder='{&quot;body&quot;: {&quot;type&quot;: &quot;order.created&quot;, &quot;customer&quot;: {&quot;phone&quot;: &quot;5511999999999&quot;, &quot;name&quot;: &quot;João&quot;}}}'
        data-testid="event-payload-example"
      ></textarea>
      <div *ngIf="availablePaths.length > 0" class="text-success small mt-1" data-testid="event-paths-extracted">
        <i class="fa fa-check me-1"></i>{{ availablePaths.length }} caminhos extraídos do JSON
      </div>
      <div
        *ngIf="form.get('payload_example')?.touched && availablePaths.length === 0 && form.get('payload_example')?.value"
        class="text-danger small mt-1"
        data-testid="event-paths-invalid"
      >
        JSON inválido — corrija para extrair os caminhos
      </div>
      <div *ngIf="form.get('payload_example')?.invalid && form.get('payload_example')?.touched && !form.get('payload_example')?.value" class="text-danger small mt-1">
        Payload obrigatório
      </div>
    </div>

    <!-- 3. Condições (match_condition) -->
    <div class="mb-3">
      <label class="form-label">Condições <span class="text-danger">*</span></label>
      <p class="small text-muted">Mínimo 1 condição. Use os caminhos extraídos do payload acima.</p>

      <div formArrayName="match_condition">
        <div
          *ngFor="let cond of conditionsFormArray.controls; let i = index; trackBy: trackByIndex"
          class="row mb-2"
          [formGroupName]="i"
        >
          <!-- Campo: SELECT com availablePaths -->
          <div class="col-md-4">
            <select
              class="form-control"
              formControlName="field"
              (change)="onConditionFieldChange(i)"
              [attr.data-testid]="'event-condition-field-' + i"
            >
              <option [ngValue]="''">-- Selecione um caminho --</option>
              <option *ngFor="let path of availablePaths" [ngValue]="path">{{ path }}</option>
            </select>
            <div *ngIf="availablePaths.length === 0" class="text-warning small mt-1">
              Cole o JSON acima primeiro
            </div>
            <div *ngIf="cond.get('field')?.invalid && cond.get('field')?.touched" class="text-danger small mt-1">
              Obrigatório
            </div>
          </div>

          <!-- Operador -->
          <div class="col-md-3">
            <select
              class="form-control"
              formControlName="operator"
              [attr.data-testid]="'event-condition-operator-' + i"
            >
              <option value="=">=</option>
              <option value="!=">!=</option>
              <option value="contains">Contém</option>
              <option value="exists">Existe</option>
            </select>
          </div>

          <!-- Valor (oculto se operator=exists) -->
          <div class="col-md-4" *ngIf="cond.get('operator')?.value !== 'exists'">
            <input
              type="text"
              class="form-control"
              formControlName="value"
              placeholder="Valor esperado"
              [attr.data-testid]="'event-condition-value-' + i"
            />
          </div>
          <div class="col-md-4" *ngIf="cond.get('operator')?.value === 'exists'"></div>

          <!-- Remove -->
          <div class="col-md-1 text-end">
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              (click)="removeCondition(i)"
              [disabled]="conditionsFormArray.length === 1"
              [attr.data-testid]="'event-condition-remove-' + i"
              title="Remover condição"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-sm btn-outline-secondary mt-2"
        (click)="addCondition()"
        [disabled]="availablePaths.length === 0"
        data-testid="event-add-condition"
      >
        <i class="fa fa-plus me-1"></i>Adicionar Condição
      </button>

      <div *ngIf="!isConditionValid && form.touched" class="text-danger small mt-2">
        Mínimo 1 condição válida obrigatória
      </div>
    </div>

    <!-- 4. Mapeamento -->
    <div class="mb-3">
      <label class="form-label">Mapeamento de Campos</label>
      <p class="small text-muted">
        Configure como cada campo do payload deve preencher a lista de leads.
      </p>

      <div formArrayName="mapping">
        <div
          *ngFor="let map of mappingFormArray.controls; let i = index; trackBy: trackByIndex"
          class="row mb-2"
          [formGroupName]="i"
        >
          <!-- Lead Column -->
          <div class="col-md-5">
            <select
              class="form-control"
              formControlName="leadColumn"
              [attr.data-testid]="'event-mapping-lead-column-' + i"
            >
              <option [ngValue]="''">-- Coluna do lead --</option>
              <option
                *ngFor="let col of leadColumns"
                [ngValue]="col.value"
                [disabled]="isLeadColumnUsed(col.value, i)"
              >{{ col.label }}</option>
            </select>
          </div>

          <div class="col-md-1 text-center pt-2">←</div>

          <!-- Source Field (path) -->
          <div class="col-md-5">
            <select
              class="form-control"
              formControlName="sourceField"
              [attr.data-testid]="'event-mapping-source-field-' + i"
            >
              <option [ngValue]="''">-- Caminho do payload --</option>
              <option *ngFor="let path of availablePaths" [ngValue]="path">{{ path }}</option>
            </select>
          </div>

          <!-- Remove -->
          <div class="col-md-1 text-end">
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              (click)="removeMapping(i)"
              [attr.data-testid]="'event-mapping-remove-' + i"
              title="Remover mapeamento"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-sm btn-outline-secondary mt-2"
        (click)="addMapping()"
        [disabled]="availablePaths.length === 0"
        data-testid="event-add-mapping"
      >
        <i class="fa fa-plus me-1"></i>Adicionar Mapeamento
      </button>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary"
    (click)="onCancel()"
    data-testid="event-cancel-btn"
  >
    Cancelar
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="onSave()"
    [disabled]="!form.valid || !isConditionValid"
    data-testid="event-save-btn"
  >
    Salvar Evento
  </button>
</div>
